window.SiteReady(($) => {
  console.log('Init Block: Header - Dole Whip');

  $headers = $('.js-header_dw');
  $carousels = $('.js-header_dw_carousel');

  function observeItems(entries) {
    entries.forEach((entry) => {
      let $el = $(entry.target);
      // let edge = window.innerHeight; // - 200;

      if (entry.isIntersecting) {
        $el.parents('.js-header_dw').addClass('scrolled');
      } else if (entry.boundingClientRect.top > 0) {
        $el.parents('.js-header_dw').removeClass('scrolled');
      }
    });
  }

  var observer = new IntersectionObserver(observeItems, {
    root: null,
    rootMargin: '0px 0px -45% 0px',
    threshold: 0.2
  });

  $carousels.each((index, el) => {
    observer.observe(el);
  });

  //

  $headers.each((index, el) => {
    let $header = $(el);
    let $triggers = $header.find('.js-destini_modal_handle');

    $header.on('click', '.js-header_dw_trigger', (e) => {
      e.preventDefault();
      e.stopPropagation();

      let $link = $(e.currentTarget);

      let href = $link.data('sku');
      let $trigger = $triggers.filter('[data-sku="' + href + '"]');

      if ($trigger.length) {
        $trigger[0].click();
      }
    });

  });

});